//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, minLength } from 'vuelidate/lib/validators';
import {
  UserAuthMixin,
  UserMixin,
  AppMixin
} from '~/node_modules/sitis-nuxt/lib/mixins';

export default {

  data: function() {
    return {
      cities: [],

      form: {
        phone: '',
        code: ''
      },

      stage: 1, // Стадия заполнения формы (всего 2)

      isLoading: false,
      isSuccessProgress: true,
      isDisablePhone: false
    };
  },

  mixins: [
    UserAuthMixin,
    UserMixin,
    AppMixin
  ],

  validations: function() {
    const form = {
      phone: { required, minLength: minLength(18) }
    };

    if (this.stage === 2) {
      form.code = { required, minLength: minLength(4) };
    }

    return {
      form
    };
  },

  mounted: async function() {
    this.$modal.show('dialog-authorization-my-acuvue');

    this.isDisablePhone = Boolean(this.user);
    this.form.phone = Boolean(this.user) ? (this.user?.phone || '').substr(1) : '';

    let { data: cities } = await this.$api.agent.transport.get("cities");
    this.cities = cities?.favorites || [];
  },

  computed: {

    isCityHasData: function () {
      const cityId = this.appCfg?.city?.model?.id || 1;
      const city = this.cities.find((t) => +t.id === +cityId);

      return Boolean(city?.has_data || false);
    }

  },

  methods: {

    // Получение кода через СМС
    getCodeFromMessage: async function() {

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$customNotification.error('Проверьте корректность заполнения формы');

        return null;
      }

      this.isLoading = true;

      const phone = this.form.phone.replace(/\D+/g, '');
      const { data: response } = await this.$api.agent.transport.post('myacuvue/request-password', {
        phone
      }).catch((err) => {
        return { data: { error: err.response } };
      });

      if (response.error) {
        this.isLoading = false;
        this.isSuccessProgress = false;

        return null;
      }

      this.isLoading = false;
      this.stage = 2;
    },

    // Авторизация в личном кабинете MyAcuvue
    authorization: async function() {

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$customNotification.error('Проверьте корректность заполнения формы');

        return null;
      }

      this.isLoading = true;

      // Подтверждение авторизации
      const phone = this.form.phone.replace(/\D+/g, '');
      const { data: response } = await this.$api.agent.transport.post('myacuvue/confirm-password', {
        phone,
        password: this.form.code
      }).catch((err) => {
        return {
          data: { error: err.response }
        };
      });

      if (response.error) {
        this.isLoading = false;

        if ((response.error?.data?.message || '').indexOf('Invalid OTP') > -1) {
          this.$customNotification.error('Введен неправильный код');
        }
        if ((response.error?.data?.message || '').indexOf('Please request a one-time pin') > -1) {
          this.$customNotification.error('Запросите новый код');
          this.stage = 1;
          this.form.code = '';
        }

        return null;
      }


      // Устоновка токена
      const { token } = response;

      const cookiesOpt = this.$getCookiesOpt({
        expires: new Date(new Date().setFullYear(new Date().getFullYear() + 5))
      })
      this.$cookies.set('authToken', token, cookiesOpt);
      this.setToken({ authToken: token });
      await this.$store.dispatch("mindbox/usersAuth");

      // Получение пользовательского провиля MyAcuvue
      const { data: profile } = await this.$api.agent.transport.get('myacuvue/me').catch((err) => {
        return { data: { error: err.response } };
      });

      // Получение пользовательского профиля
      await this.getUser({expanded: true});

      // Запись провиля в хранилище
      this.$store.commit('myacuvue/setProfile', profile);
      this.$store.commit('myacuvue/setLoading', false);

      this.$emit('close');

      if ( this.$route.name !== "cart" ) {
        window.location.href = "/profile/my-acuvue";
      } else {
        window.location.reload();
      }
    },

    // Переход в раздел MyAcuvue
    routeMyAcuvue: function() {
      this.$router.push('/acuvue');
      this.$emit('close');
    },

    // Закрытие окна авторизации
    onClose: function () {
      this.$modal.hide('dialog-authorization-my-acuvue');

      this.$emit('close');
    },

    routeKontakty: function () {
      this.onClose();

      window.open('/kontakty', '_blank');

      // this.$router.push('/kontakty');
    }

  }

};
